export const getSingleEncryptPseudonymCount = (state) =>
    state.encryptPseudonym.encryptSinglePseudonyms.maxCount;
